module.exports = __webpack_public_path__ + "img/hambre_de_crecer.e20f0be8.webp";